<template>
  <div class="btn__inner">  
    <button  
      class="btn btn-light"  
      type="button"  
      @click="doDiminish"  
    >-</button>  
    <span class="pd__counter">{{ counter }}</span>  
    <button  
      class="btn btn-light"  
      type="button"  
      @click="doIncrease"  
    >+</button>  
  </div>  
</template>

<script>
export default {
  data() {  
    return {  
      counter: 0,  
    };  
  },  
  methods: {  
    doIncrease() {  
      if (this.counter === 5) {  
        this.counter = 5;  
      } else {  
        this.counter++;  
        this.$parent.$parent.$emit('increase');  
      }  
    },  
    doDiminish() {  
      if (this.counter === 0) {  
        this.counter = 0;  
      } else {  
        this.counter--;  
        this.$parent.$parent.$emit('diminish',);  
      }  
    }  
  },
}
</script>

<style>
.pd__counter {
  font-size: 1.5em;
}

.pd .btn {
  font-size: 1.5em;
  line-height: 1;
  border-radius: 3px;
  padding: 5px 15px;
  outline: none;
}

.pd .btn:hover {
  background-color: #eee;
}

.pd .btn__inner {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.pd .btn-light {
  color: #666;
  background-color: #fff;
  border: solid 1px #ddd;
}
</style>



// WEBPACK FOOTER //
// src/components/Prod/ProdCounter.vue